export default __webpack_public_path__ + "static/media/pic_gta.dc3fe96a.jpg";